<div class="flow-datepicker">
  <label>
    <ng-content></ng-content>
  </label>

  @if (showInput) {
    <div (click)="openDatepicker()" class="datepicker-container">
      <div class="input-div icon">
        {{ formattedValue }}
      </div>
      <ion-icon name="calendar-outline"></ion-icon>
    </div>
  }
  <ion-content>
    <ion-modal class="datepicker-modal" [keepContentsMounted]="true" #datepickerModal>
      <ng-template>
        <ion-datetime
          [value]="value?.toISOString()"
          [cancelText]="'lbl_cancel' | translate"
          [doneText]="'lbl_accept' | translate"
          [firstDayOfWeek]="1"
          presentation="date"
          [locale]="locale"
          showDefaultButtons="true"
          (ionChange)="handleChange($event)"
          [max]="max?.toISOString()"
        ></ion-datetime>
      </ng-template>
    </ion-modal>
  </ion-content>

</div>
